import { ChainId } from '../constant';
import { Client } from './type';

export default {
    [ChainId.lazaiMainnet]: {
        [Client.graph]: 'https://lazbubu-api.lazai.network/',
        [Client.lazpad]: 'https://api.lazpad.fun/lazai',
    },
    [ChainId.lazaiTestnet]: {
        [Client.graph]: 'https://lazbubu-backend-b3z67.ondigitalocean.app/',
        [Client.lazpad]: 'https://api.lazpad.fun/lazai',
    },
    [ChainId.bscMainnet]: {
        [Client.graph]: 'https://api.lazbubu.ai',
        [Client.lazpad]: 'https://api.lazpad.fun/lazai',
        [Client.task]: 'https://task.lazai.network/lazai',
    },
    [ChainId.bscTestnet]: {
        [Client.graph]: 'https://seahorse-app-x3bvj.ondigitalocean.app/',
        [Client.lazpad]: 'https://api.lazpad.fun/lazai',
        [Client.task]: 'https://task.lazai.network/lazai',
    },
};
